import { MENU_TYPES } from '../constants.js';
import { BaseMenuEntityConfiguration } from '../entityConfigs/index.js';
export default new BaseMenuEntityConfiguration({
    consumable: false,
    filters: [
        {
            name: 'type',
            options: MENU_TYPES,
            type: 'Select',
        },
        {
            name: 'allowInstructions',
            type: 'Boolean',
        },
    ],
    hasDescription: false,
    hasHours: true,
    hasImage: false,
    hasVariations: false,
    hasPos: true,
    lists: [
        {
            collection: 'Category',
            name: 'categories',
            primaryRelationship: true,
        },
    ],
    name: 'Menu',
    options: {
        type: 'olo',
        allowInstructions: false,
        showNutritionalInformation: true,
    },
    pluralizedName: 'Menus',
    sellable: false,
    sortKeys: [],
    unlinkedOptions: [],
    version: 8,
});
//# sourceMappingURL=menu.js.map